import { render, staticRenderFns } from "./VgtMenu.vue?vue&type=template&id=0a5158c4&lang=pug&"
import script from "./VgtMenu.vue?vue&type=script&lang=js&"
export * from "./VgtMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports